
import { Cpu, ShieldCheck, Atom, Zap, Layers, HeartPulse } from 'lucide-react';
import { Link } from 'react-router-dom';

const FocusSectorsSectionEn = () => {
  return (
  <section className="py-24 bg-gradient-to-br from-[hsl(var(--focus-areas-start))] via-[hsl(var(--focus-areas-mid))] to-[hsl(var(--focus-areas-end))]">
    <div className="w-full px-8 md:px-16 lg:px-24">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16 animate-on-scroll">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6 text-gray-900">Focus Areas</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 animate-on-scroll">
          <Link to="/en/focus-areas/ai-autonomous" className="group">
            <div className="bg-white rounded-2xl shadow-xl p-8 text-center flex flex-col items-center group-hover:shadow-2xl transition-all duration-300 group-hover:scale-105">
              <Cpu className="w-10 h-10 mb-4 text-blue-700" />
              <h3 className="text-2xl font-bold mb-2 text-blue-700">AI & Autonomous Systems</h3>
              <p className="text-gray-600">for societal transformation</p>
            </div>
          </Link>
          <Link to="/en/focus-areas/digital-technology" className="group">
            <div className="bg-white rounded-2xl shadow-xl p-8 text-center flex flex-col items-center group-hover:shadow-2xl transition-all duration-300 group-hover:scale-105">
              <ShieldCheck className="w-10 h-10 mb-4 text-green-700" />
              <h3 className="text-2xl font-bold mb-2 text-green-700">Digital Technology</h3>
              <p className="text-gray-600">for productivity and security</p>
            </div>
          </Link>
          <Link to="/en/focus-areas/quantum" className="group">
            <div className="bg-white rounded-2xl shadow-xl p-8 text-center flex flex-col items-center group-hover:shadow-2xl transition-all duration-300 group-hover:scale-105">
              <Atom className="w-10 h-10 mb-4 text-purple-700" />
              <h3 className="text-2xl font-bold mb-2 text-purple-700">Quantum</h3>
              <p className="text-gray-600">for security and industry</p>
            </div>
          </Link>
          <Link to="/en/focus-areas/energy" className="group">
            <div className="bg-white rounded-2xl shadow-xl p-8 text-center flex flex-col items-center group-hover:shadow-2xl transition-all duration-300 group-hover:scale-105">
              <Zap className="w-10 h-10 mb-4 text-yellow-700" />
              <h3 className="text-2xl font-bold mb-2 text-yellow-700">Energy</h3>
              <p className="text-gray-600">for fossil-free electrification</p>
            </div>
          </Link>
          <Link to="/en/focus-areas/materials" className="group">
            <div className="bg-white rounded-2xl shadow-xl p-8 text-center flex flex-col items-center group-hover:shadow-2xl transition-all duration-300 group-hover:scale-105">
              <Layers className="w-10 h-10 mb-4 text-pink-700" />
              <h3 className="text-2xl font-bold mb-2 text-pink-700">Materials</h3>
              <p className="text-gray-600">for transformation</p>
            </div>
          </Link>
          <Link to="/en/focus-areas/biotechnology" className="group">
            <div className="bg-white rounded-2xl shadow-xl p-8 text-center flex flex-col items-center group-hover:shadow-2xl transition-all duration-300 group-hover:scale-105">
              <HeartPulse className="w-10 h-10 mb-4 text-teal-700" />
              <h3 className="text-2xl font-bold mb-2 text-teal-700">Biotechnology</h3>
              <p className="text-gray-600">for health and climate</p>
            </div>
          </Link>
        </div>
      </div>
    </div>
  </section>
  );
};

export default FocusSectorsSectionEn;
